import { CzechDocumentType } from "@tymbe/legislatives/czechia/CzechDocumentType";

export const documentTypeNameMap: Record<CzechDocumentType, string> = {
  [CzechDocumentType.DokladODosazeniZakladnihoVzdelani]: "Doklad o dosažení základního vzdělání",
  [CzechDocumentType.PotvrzeniJinehoZamestnavateleOOdvoduZdravotnihoPojisteni]: 'Potvrzení jiného zaměstnavatele o odvodu zdravotního pojištění',
  [CzechDocumentType.PotvrzeniOEvidenciNaUraduPrace]: 'Potvrzení o evidenci na úřadu práce',
  [CzechDocumentType.PotvrzeniOPeciODite]: "Potvrzení o péči o dítě",
  [CzechDocumentType.PotvrzeniOStudiu]: 'Potvrzení o studiu',
  [CzechDocumentType.ProhlaseniPoplatnika]: 'Prohlášení poplatníka',
  [CzechDocumentType.PrukazZTPP]: 'Průkaz ZTP/P',
  [CzechDocumentType.Smlouva]: "Smlouva",
  [CzechDocumentType.VstupniLekarskaProhlidka]: "Vstupní lékařská prohlídka",
  [CzechDocumentType.VymerInvalidnihoDuchodu12Stupne]: 'Výměr invalidního důchodu 1., 2. stupně',
  [CzechDocumentType.VymerInvalidnihoDuchodu1Stupne]: 'Výměr invalidního důchodu 1. stupně',
  [CzechDocumentType.VymerInvalidnihoDuchodu2Stupne]: 'Výměr invalidního důchodu 2. stupně',
  [CzechDocumentType.VymerInvalidnihoDuchodu3Stupne]: 'Výměr invalidního důchodu 3. stupně',
  [CzechDocumentType.VymerMaterskeRodicovskeDovolene]: 'Výměr mateřské rodičovské dovolené',
  [CzechDocumentType.VymerStarobnihoDuchodu]: 'Výměr starobního důchodu',
}
